import { useCallback, type MouseEvent, type ReactNode } from "react";
import { useAuth } from "./useAuth";

export interface ModuleLogoutButtonProps {
  className?: string;
  label?: ReactNode;
}

/** Déconnexion IAM centralisée (Suite /auth/logout) — ne pas lier vers /login local. */
export function ModuleLogoutButton({
  className = "btn btn-sm btn-outline-secondary",
  label = "Déconnexion",
}: ModuleLogoutButtonProps) {
  const { logout } = useAuth();

  const handleLogout = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      void logout();
    },
    [logout],
  );

  return (
    <button type="button" className={className} onClick={handleLogout}>
      {label}
    </button>
  );
}
